export const FEATURE_KEY = 'fabric-editor-onboarding-spotlight';

// Copied from confluence-frontend-server/src/components/Changeboarding/changeboarding-spotlights.js
export const HELP_MENU_SPOTLIGHT = 'editor.help.center.spotlight.on.help.menu';

export const EDITOR_IMPROVEMENTS_URL =
	'https://confluence.atlassian.com/confcloud/confluence-editing-improvements-945107733.html';

export const EDITOR_TEMPLATES_URL =
	'https://confluence.atlassian.com/display/ConfCloud/Create+a+page+from+a+template';

export const CAC_HELP_LINKS = {
	EDITING_IMPROVEMENTS:
		'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements',
	MEETING_NOTES: 'https://www.atlassian.com/software/confluence/templates/meeting-notes',
	BLOGS_UPDATE:
		'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-blogposts',
	MEETING_NOTES_UPDATE:
		'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-meetingnotes',
};

export const CONTEXTUAL_EDITOR_HELP_LINKS = {
	'meeting-notes': [
		{
			href: CAC_HELP_LINKS.MEETING_NOTES,
			title: 'editor.help.how.to.use.blueprint',
		},
	],
};

export const PREDEFINED_BLUEPRINT_TYPES_TITLES = {
	'meeting-notes': 'content.kind.meeting-notes',
	decisions: 'content.kind.decisions',
	'kb-how-to-article': 'content.kind.kb-how-to-article',
	'file-list': 'content.kind.file-list',
	retrospective: 'content.kind.retrospective',
	requirements: 'content.kind.product-requirements',
	'shared-links': 'content.kind.shared-links',
	'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
	'task-report': 'content.kind.task-report',
	jirareport: 'content.kind.jirareport',
};
